/**
 * 店舗の地図・電話。Vite の環境変数で指定（.env / .env.production.local）。
 * 未設定の項目はボタンを出さない。
 */

function normalizePhoneDigits(raw: string): string {
  return raw.replace(/\D/g, "");
}

export function getStorePhoneDigits(): string | null {
  const raw = (import.meta.env.VITE_STORE_PHONE ?? "").trim();
  const d = normalizePhoneDigits(raw);
  return d.length > 0 ? d : null;
}

/** 画面表示用（ハイフンは元の文字列を優先） */
export function getStorePhoneLabel(): string | null {
  const raw = (import.meta.env.VITE_STORE_PHONE ?? "").trim();
  if (!raw) return null;
  const d = normalizePhoneDigits(raw);
  return d.length > 0 ? raw : null;
}

/** Google マップの検索クエリ（住所や店名） */
export function getStoreMapQuery(): string | null {
  const q = (import.meta.env.VITE_STORE_MAP_QUERY ?? "").trim();
  return q.length > 0 ? q : null;
}

export function getGoogleMapsSearchUrl(): string | null {
  const q = getStoreMapQuery();
  if (!q) return null;
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;
}

export function dialStorePhone(): void {
  const d = getStorePhoneDigits();
  if (!d || typeof window === "undefined") return;
  window.location.href = `tel:${d}`;
}
